import React from 'react';
import { Redirect, withRouter, matchPath } from 'react-router-dom';
import { THREAT_INTEL_CUST_LICENSE_CODE, THREAT_INTEL_CUST_VALID_PATHS } from '../utilities/threatIntelCustomerUtils';

class ThreatIntelCustomerRedirect extends React.Component {
  render() {
    const { userRole, licenseType } = this.props;
    const pathname = this.props.location.pathname;
    if (
      userRole === 'CustomerAdmin' &&
      licenseType === THREAT_INTEL_CUST_LICENSE_CODE &&
      !THREAT_INTEL_CUST_VALID_PATHS.some(validPath =>
      matchPath(pathname, { path: validPath, exact: true, strict: false }))
    ) {
      return <Redirect to="/threat-intel" />;
    }
    return null;
  }
}

export default withRouter(ThreatIntelCustomerRedirect);